<script type="text/jsx">
import mixin from '@/plans/mx/shopping-cart';
import mxPlanConfig from '@/plans/VIDEO_SDK_UC/mixin';
import { getPlanUnitWithQuantity, planUnitMap } from '@/common/product-unit';

export default {
  mixins: [mixin, mxPlanConfig],
  name: 'SDKUCCart',
  methods: {
    mx_freeTrialDesc(credit) {
      return (
        <div class="opc-cart-item__text">
          <p class="opc-cart-item__duration-text">{this.$t('billing.trial.duration_desc_credit', [credit])}</p>
          <p>{this.mx_freeTrialStartDate()}</p>
        </div>
      );
    },
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            {
              /* FREE TRIAL - Specific UI for free trial */
            }
            if (!!plan.isOnlineFreeTrial && !!plan.trialDays) {
              return (
                <div>
                  {this.mx_freeTrialTitle(this.title, plan?.plan_code)}
                  {this.mx_freeTrialDesc(plan.credit)}
                  {this.mx_discount(plan.plan_code)}
                  {this.showRemove && this.mx_remove(plan)}
                  {this.mx_edit(plan)}
                </div>
              );
            }
            return (
              <div>
                {this.mx_title(this.title, this.mx_price(plan))}
                {this.mx_license(plan?.credit, getPlanUnitWithQuantity(planUnitMap.credits))}
                {this.mx_cycle(plan.billing_cycle)}
                {this.mx_edit(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>
